let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dSv74")).then(() => parcelRequire('12n7A'));